import React from 'react';

const NotFound = () => {
  return (
    <h4 className="not-found">
      Sorry, but the page you have requested was not found.
    </h4>
  );
};

export default NotFound;
